import React from 'react';
import { Chip } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import type { SlaveCompleteEvent } from '../../types';
import { formatTokens, formatUsd } from '../../services/usage.service';

export const UsageChip: React.FC<{ slaveComplete: SlaveCompleteEvent }> = ({ slaveComplete }) => {
  const cost = slaveComplete.cost_usd;
  const total = slaveComplete.tokens?.total;
  if (cost == null && total == null) return null;

  let label: string;
  if (total != null && cost != null) {
    label = `${formatTokens(total)} tokens · ${formatUsd(cost)}`;
  } else if (total != null) {
    label = `${formatTokens(total)} tokens`;
  } else {
    label = `Cost: ${formatUsd(cost!)}`;
  }
  const sx = { fontFamily: 'monospace', fontSize: '0.75rem' };
  if (slaveComplete.prompt_group_id) {
    return (
      <Chip size="small" variant="outlined" clickable component={RouterLink}
        to={`/usage?prompt=${slaveComplete.prompt_group_id}`} label={label} sx={sx} />
    );
  }
  return <Chip size="small" variant="outlined" label={label} sx={sx} />;
};

export default UsageChip;
